export default {
  title: 'Omdøb tilbud',
  subtitle: 'Indtast et nyt navn til dit tilbud (maks. 40 tegn)',
  toasts: {
    success: 'Tilbuddet er omdøbt',
    error: 'Tilbuddet kunne ikke omdøbes',
  },
  buttons: {
    rename: 'Omdøb',
  },
  form: {
    title: {
      label: 'Tilbudsnavn',
      placeholder: 'Indtast tilbudsnavn',
    },
  },
};
